// extracted by mini-css-extract-plugin
export var anchor = "component-module--anchor--40a40";
export var btnFacebook = "component-module--btn-facebook--71964";
export var btnLinkedin = "component-module--btn-linkedin--619f8";
export var btnWechat = "component-module--btn-wechat--06dd1";
export var btnWrap = "component-module--btnWrap--1db72";
export var btnXing = "component-module--btn-xing--4f752";
export var btnYoutube = "component-module--btn-youtube--89071";
export var cameraAccessoriesListingPager = "component-module--cameraAccessoriesListingPager--332ba";
export var container = "component-module--container--18a3a";
export var dark = "component-module--dark--bacdf";
export var grid = "component-module--grid--eca60";
export var icon = "component-module--icon--e48f4";
export var iconText = "component-module--icon-text--e8c92";
export var light = "component-module--light--4e2d0";
export var mail = "component-module--mail--2f30f";
export var mobileTeasers = "component-module--mobileTeasers--8665c";
export var nestedContentTeaser = "component-module--nestedContentTeaser--7ac48";
export var newsDetailWrap = "component-module--newsDetailWrap--63419";
export var oneColumn = "component-module--oneColumn--cbe1c";
export var phone = "component-module--phone--53374";
export var printer = "component-module--printer--6c2f0";
export var reducedWidth = "component-module--reducedWidth--18027";
export var structuredTextContainer = "component-module--structuredTextContainer--57c3d";
export var teaserBottomContent = "component-module--teaserBottomContent--65d2c";
export var textCap = "component-module--textCap--6eb6c";
export var twoColumn = "component-module--twoColumn--a21b2";